import { Children, Fragment, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import {
  Toolbar,
  SaveButton,
  List,
  SimpleForm,
  DateInput,
  DateField,
  TextInput,
  Datagrid,
  Edit,
  Create,
  TextField,
  ReferenceField,
  ReferenceInput,
  NumberField,
  SelectInput,
  required,
  choices,
  FormDataConsumer,
  useUpdate,
  ReferenceManyField,
  AutocompleteInput,
  Show,
  SimpleShowLayout,
  useDataProvider,
  useRefresh,
  useGetOne,
  useNotify,
  BooleanInput,
  RichTextField,
  Loading,
  useGetList,
  useTranslate,
  useRedirect,
  useRecordContext,
  FilterButton,
  FilterForm,
  useGetManyReference,
  DateTimeInput,
  TopToolbar,
  DatagridBody,
  RecordContextProvider,
  useGetIdentity,
  Filter,
  ReferenceArrayInput,
  AutocompleteArrayInput,
} from 'react-admin'

import { useFormContext } from 'react-hook-form'
import { useChoicesContext, useListContext } from 'ra-core'
import {
  Button,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Badge,
  List as ListM,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Box,
  FormControlLabel,
  Checkbox,
  Modal,
  Slide,
  TextField as TextFieldUI,
  DialogContentText,
  Drawer,
  useMediaQuery,
} from '@material-ui/core'
import Chip from '@mui/material/Chip'
import { makeStyles, styled } from '@material-ui/core/styles'
import {
  CustomToolbar,
  validatePhone,
  formatPhone,
  ExtraPagination,
  draft_color,
} from './utils'
import {
  DynamicInputComponentBO,
  DynamicViewComponentBO,
} from './tickets_common'
import { TicketListDraft } from './ticket_list_draft'
import { parse } from 'query-string'
import {
  HorizontalRule as PriorityLowIcon,
  DensityLarge as PriorityMediumIcon,
  DensityMedium as PriorityHighIcon,
  Edit as EditIcon,
  Email as EmailIcon,
  RemoveRedEye as RemoveRedEyeIcon,
  Description as DescriptionIcon,
  AddIcCall as AddIcCallIcon,
  Star as StarIcon,
  Delete as DeleteIcon,
  Comment as CommentIcon,
  Visibility as VisibilityIcon,
  Warning as WarningIcon,
  CalendarMonth,
  OutboxOutlined,
  KeyboardArrowRight,
  Clear as ClearIcon,
} from '@mui/icons-material'
import moment from 'moment'
import Alert from './components/alert'
import Pill from './components/pill'
import Snackbar from './components/snackbar'
import TextFieldWithTooltip from './components/text_field_with_tooltip'
import { DialogForm } from './components/DialogForm'
import { TranslateWrapperTextField } from './components/translatable_field_wrapper'
import UpsertFileButton, {
  LinkRelationFromParent,
  SaveNewWithFileButton,
} from './components/file_upload'
import { HtmlTooltip } from './components/html_tooltip'
import FileWithContext from './models/file_with_context'
import { createPopup } from '@typeform/embed'
import '@typeform/embed/build/css/popup.css'
import Relation from './models/relation'
import BindFile from './exceptions/file_with_context/bind_file'
import illustrationProchaineAction from './assets/images/illustrationProchaineAction.svg'
import Api from './Apis/api.service'
import DateRangePicker from './components/common/DateRangePicker/DateRangePicker'
import config from './config'
import { openInNewTab } from './utils'
import SplitButton from './common/Buttons/SplitButton'
import Interlocutors from './intranet/Tickets/Interlocutors'
import Comments from './intranet/Tickets/comments'
import { getComments } from './intranet/Tickets/comments/api'
import CommentsList from './intranet/Tickets/comments/components/CommentsList'
import ApiCopros from './intranet/Copros/api/apiCopros'
import { DRAFT_TICKET_TYPE, ZendeskModal } from './zendesk/ZendeskModal'
import { CircularProgress, InputAdornment, ToggleButton } from '@mui/material'
import { FrontModal } from './front/FrontModal'

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

const CustomField = (props) => {
  const record = useRecordContext()

  if (record.tokens === undefined) {
    return null
  }
  const user_type = window.context['user_type']
  return (
    <div>
      {user_type?.includes('Admin') ? (
        <div>
          {record.tokens.map((obj, index) => {
            return (
              <div key={index}>
                <Typography>
                  <Link
                    href={
                      window.location.origin + '/ext_tickets/' + obj['token']
                    }
                    target="_blank"
                    variant="body2"
                  >
                    Espace unique {obj['role']}
                  </Link>
                </Typography>
              </div>
            )
          })}
        </div>
      ) : (
        <div />
      )}
      {!user_type?.includes('Admin') ? <div></div> : <div />}
    </div>
  )
}

const ArchiveButton = ({ record, open, setOpen, func, ...props }) => {
  if (!record) return null
  return (
    <>
      {!record.done ? (
        <Dialog aria-labelledby="simple-dialog-title" open={open}>
          <div style={{ padding: '20px' }}>
            <Typography>
              Ce ticket n'a pas atteint la dernière étape. Etes-vous sur de
              vouloir l'archiver ?
            </Typography>
            <br />
            <Button
              size="small"
              variant="contained"
              color="secondary"
              onClick={() => func({ fastForward: true })}
              disableElevation
            >
              Finaliser et archiver
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => func({ fastForward: false })}
              disableElevation
              style={{ marginLeft: '10px' }}
            >
              Archiver tel quel
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={() => setOpen(false)}
              style={{ marginLeft: '10px' }}
            >
              Annuler
            </Button>
          </div>
        </Dialog>
      ) : null}
    </>
  )
}
const DesarchiveButton = ({ record, refresh, open, setOpen, ...props }) => {
  const [loading, setLoading] = useState(false)
  const notify = useNotify()
  const dataProvider = useDataProvider()
  if (!record) return null

  const func = () => {
    setLoading(true)
    dataProvider
      .update('tickets', {
        id: record.id,
        data: { ...record, archived: !record.archived },
      })
      .then((response) => {
        setLoading(false)
        setOpen(false)
        notify('Succès')
        refresh()
      })
      .catch((error) => {
        setLoading(false)
        notify(`${error.message}`, 'warning')
      })
  }
  return (
    <>
      <Dialog aria-labelledby="simple-dialog-title" open={open}>
        <div style={{ padding: '20px' }}>
          <Typography>Etes-vous sur de vouloir Désarchiver ?</Typography>
          <br />
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => func()}
            disabled={loading}
            disableElevation
          >
            Désarchiver
          </Button>
          <Button
            size="small"
            variant="outlined"
            onClick={() => setOpen(false)}
            style={{ marginLeft: '10px' }}
          >
            Annuler
          </Button>
        </div>
      </Dialog>
    </>
  )
}

const SimpleDialog = (props) => {
  const { onClose, open } = props
  const handleClose = () => {
    onClose()
  }

  return <></>
}

const CommentButton = ({ record, comments }) => {
  const commentsData = comments ?? record.comments
  const commentsCount = commentsData?.length || 0
  const commentsSeen = comments !== undefined ? true : record.comments_seen
  const hasComments = commentsCount > 0

  if (!hasComments) {
    return (
      <Tooltip title="Aucun commentaire">
        <CommentIcon color="disabled" />
      </Tooltip>
    )
  }

  const badgeColor = !commentsSeen ? 'error' : 'secondary'

  return (
    <Badge
      badgeContent={commentsCount}
      color={badgeColor}
      overlap="circular"
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <CommentIcon />
    </Badge>
  )
}
const CommentDialog = ({ setOpen, open, ...props }) => {
  const record = useRecordContext()
  if (!record) return null

  return (
    <Comments
      record={record}
      openModalComments={open}
      setOpenModalComments={setOpen}
      type={'tickets'}
    />
  )
}

// @todo: find a better way to pass the link to.
const SmallIconButton = ({ record, onClick, ...props }) => {
  const redirect = useRedirect()

  return (
    <IconButton
      {...props}
      onClick={() => {
        onClick ? onClick() : redirect(record.to, 'tickets', record.id)
      }}
    />
  )
}

const ButtonsColumn = ({ archivedmode, width, ...props }) => {
  const record = useRecordContext()
  const user_type = window.context['user_type']
  const [openShowGeneric, setOpenShowGeneric] = useState(false)
  const redirect = useRedirect()
  const refresh = useRefresh()
  const notify = useNotify()
  const dataProvider = useDataProvider()
  const [openCustomNotifDialog, setOpenCustomNotifDialog] = useState(false)
  const [openComments, setOpenComments] = useState(false)
  const [openZendeskModal, setOpenZendeskModal] = useState(false)
  const [openFrontModal, setOpenFrontModal] = useState(false)
  const [openArchive, setOpenArchive] = useState(false)
  const [openDesarchive, setOpenDesarchive] = useState(false)
  const [openDialogInterlocutors, setOpenDialogInterlocutors] = useState(false)
  const refLinkType = useRef(null)
  // CHECK IF HAS ANY DOCUMENTS
  const getCountDocuments = async (record) => {
    let count = 0
    const res = await Api.fileWithContext.getCount({
      filter: JSON.stringify({
        linkable_id: record?.id,
        linkable_type: 'tickets',
      }),
      range: '{}',
    })
    if (res.status == 200) {
      count = parseInt(res.data.count)
    }
    return count
  }
  let toggleArchive = {}
  let spacesPrestas = []
  if (record.tokens === undefined) {
    spacesPrestas = []
  }
  if (user_type?.includes('Admin')) {
    {
      record.tokens.map((obj) => {
        const url = window.location.origin + '/ext_tickets/' + obj['token']
        let roleStr = obj['role']
        roleStr =
          roleStr == 'hs'
            ? roleStr.toUpperCase()
            : roleStr.charAt(0).toUpperCase() + roleStr.slice(1)
        spacesPrestas.push({
          option: `Espace ${roleStr}`,
          onClick: () => {
            openInNewTab(url)
          },
          disabled: false,
        })
      })
    }
  }
  const func = ({ fastForward = false }) => {
    dataProvider
      .update('tickets', {
        id: record.id,
        data: { ...record, archived: true, fastForward },
      })
      .then((response) => {
        notify('Succès')
        refresh()
      })
      .catch((error) => {
        notify(`${error.message}`, 'warning')
      })
    setOpenArchive(false)
  }

  if (archivedmode === true || (record && record.archived === true)) {
    toggleArchive = {
      option: 'Désarchiver',
      onClick: () => {
        setOpenDesarchive(true)
      },
      disabled: false,
    }
  } else {
    toggleArchive = {
      option: 'Archive',
      onClick: () => {
        if (!record.done) setOpenArchive(true)
        else func({ fastForward: false })
      },
      disabled: false,
    }
  }
  const generateActions = async (record) => {
    const count = await getCountDocuments(record)
    return [
      {
        option: 'Voir plus',
        onClick: () => {
          setOpenShowGeneric(true)
        },
        disabled: false,
      },
      {
        option: 'Editer',
        onClick: () => {
          redirect('edit', 'tickets', record.id)
        },
        disabled: false,
      },
      {
        option: 'Relance',
        onClick: () => {
          setOpenCustomNotifDialog(true)
        },
        disabled: false,
      },
      {
        option: (
          <>
            <span>Documents</span>
          </>
        ),
        onClick: () => {
          refLinkType?.current?.children[0].click()
        },
        disabled: count > 0 ? false : true,
      },
      {
        option: (
          <>
            <span>Appel</span>
          </>
        ),
        onClick: () => {
          setOpenDialogInterlocutors(true)
        },
      },
      ...spacesPrestas,
      toggleArchive,
    ]
  }

  return (
    <>
      {openDialogInterlocutors && (
        <Interlocutors
          ticketId={record.id}
          setOpenDialogInterlocutors={setOpenDialogInterlocutors}
          openDialogInterlocutors={openDialogInterlocutors}
        />
      )}
      <span ref={refLinkType} style={{ display: 'none' }}>
        <LinkType
          color="primary"
          size="small"
          linkable_type={'tickets'}
          record={record}
        />
      </span>
      <TicketShowGeneric
        open={openShowGeneric}
        setOpen={setOpenShowGeneric}
        id={record.id}
        basePath="/tickets"
        resource="tickets"
      />

      <CommentDialog setOpen={setOpenComments} open={openComments} />
      {openZendeskModal && (
        <ZendeskModal
          open={openZendeskModal}
          handleClose={() => {
            setOpenZendeskModal(!openZendeskModal)
            // we have to force the reload to update the react admin record of the tickets
            location.reload()
          }}
          ticket={{
            id: record.id,
            reference: record.reference,
            code: record.code,
          }}
        />
      )}
      {openFrontModal && (
        <FrontModal
          open={openFrontModal}
          handleClose={() => {
            setOpenFrontModal(!openFrontModal)
            refresh()
          }}
          ticket={{
            id: record.id,
            reference: record.reference,
            code: record.code,
          }}
        />
      )}
      <CustomNotifDialog
        {...props}
        record={record}
        open={openCustomNotifDialog}
        handleClose={() => {
          setOpenCustomNotifDialog(false)
        }}
      />
      <ArchiveButton
        {...props}
        record={record}
        open={openArchive}
        setOpen={setOpenArchive}
        func={func}
        color="primary"
        size="small"
      />
      <DesarchiveButton
        refresh={refresh}
        record={record}
        open={openDesarchive}
        setOpen={setOpenDesarchive}
      />

      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          columnGap: '10px',
          width: '100%',
        }}
      >
        <SplitButton
          getActions={async () => {
            return await generateActions(record)
          }}
          style={{ marginRight: 'auto' }}
        />
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0px',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <SmallIconButton
            color="primary"
            size="small"
            disableRipple={true}
            onClick={() => {
              setOpenComments(true)
            }}
            style={{
              opacity: record?.archived ? 0.2 : 1,
            }}
          >
            <CommentButton record={record} />
          </SmallIconButton>
          <IconButton
            {...props}
            onClick={() => setOpenFrontModal(true)}
            style={{
              opacity: record?.archived ? 0.2 : 1,
              padding: '5px',
            }}
          >
            {record.front_conversations_count > 0 ? (
              <Badge
                badgeContent={record.front_conversations_count}
                color="primary"
                overlap="circular"
              >
                <EmailIcon color="primary" />
              </Badge>
            ) : (
              <EmailIcon color="disabled" />
            )}
          </IconButton>
        </Box>
      </Box>
    </>
  )
}

const BackButton = (props) => {
  if (props.listmode === false || props.listmode === undefined) {
    return null
  }
  const handleClick = (event) => {
    props.setListmode(false)
  }
  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={handleClick}
      style={{ marginLeft: '10px' }}
    >
      Revenir au résumé
    </Button>
  )
}

const DeadlinePillWrapper = () => {
  const record = useRecordContext()
  if (!record) return null
  const deadline = moment(record.deadline)
  const today = moment()
  const isPast = moment(deadline).isBefore(today) && record.step === 1

  return record.deadline ? (
    <Pill
      id={record.id}
      value={deadline.format('D/M/Y')}
      status={isPast ? 'error' : 'success'}
    />
  ) : (
    <></>
  )
}

const StepPillWrapper = () => {
  const record = useRecordContext()
  if (!record || record.status === undefined) return null

  return (
    <Tooltip title={record.status}>
      <div>
        <Pill
          id={record.id}
          value={record.status}
          status="secondary"
          style={{ color: 'black' }}
        />
      </div>
    </Tooltip>
  )
}

const ProchaineActionFilter = () => {
  return (
    <Box>
      <DateInput
        source="next_action_at_start"
        label="Début Prochaine Action"
        alwaysOn
        sx={{
          marginRight: '16px',
          '& .MuiInputBase-root': {
            minWidth: '170px !important',
          },
        }}
      />
      <DateInput
        source="next_action_at_end"
        label="Fin Prochaine Action"
        alwaysOn
        sx={{
          '& .MuiInputBase-root': {
            minWidth: '170px !important',
          },
        }}
      />
    </Box>
  )
}

const ListActions = (props) => {
  const { handleSelect, dateRange } = props

  const { setFilters, filterValues = {} } = useListContext()
  const { identity } = useGetIdentity()
  const currentUserId = identity?.id

  const handleSetOwner = (newOwnerId) => {
    setFilters({
      ...filterValues,
      owner_id: filterValues.owner_id === newOwnerId ? undefined : newOwnerId,
    })
  }

  const handleSetCreator = (newCreatorId) => {
    setFilters({
      ...filterValues,
      creator_id:
        filterValues.creator_id === newCreatorId ? undefined : newCreatorId,
    })
  }

  return (
    <TopToolbar
      sx={{
        mt: 1,
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid
          item
          container
          spacing={2}
          alignItems="center"
          justifyContent="flex-start"
        >
          <Grid item>
            <style>
              {`
                .rdrDateDisplay {
                  margin-left: 0 !important;
                }
              `}
            </style>
            <DateRangePicker
              handleSelect={handleSelect}
              ranges={dateRange}
              collapsed={true}
              maxDate={new Date()}
              source={'tickets'}
              style={{
                padding: 0,
                margin: 0,
              }}
            />
          </Grid>
          <Grid item>
            <ToggleButton
              value="creator"
              selected={filterValues.creator_id === currentUserId}
              onChange={() => handleSetCreator(currentUserId)}
              size="small"
              sx={{
                backgroundColor:
                  filterValues.creator_id === currentUserId
                    ? 'transparent'
                    : 'primary.main',
                color:
                  filterValues.creator_id === currentUserId
                    ? 'primary.main'
                    : 'white',
                boxShadow:
                  filterValues.creator_id === currentUserId
                    ? 'inset 0px 4px 6px rgba(0,0,0,0.2)'
                    : '0px 4px 6px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  backgroundColor:
                    filterValues.creator_id === currentUserId
                      ? 'primary.dark'
                      : 'primary.light',
                },
              }}
            >
              Mes tickets créés
            </ToggleButton>
          </Grid>
          <Grid item>
            <ToggleButton
              value="owner"
              selected={filterValues.owner_id === currentUserId}
              onChange={() => handleSetOwner(currentUserId)}
              size="small"
              sx={{
                backgroundColor:
                  filterValues.owner_id === currentUserId
                    ? 'transparent'
                    : 'primary.main',
                color:
                  filterValues.owner_id === currentUserId
                    ? 'primary.main'
                    : 'white',
                boxShadow:
                  filterValues.owner_id === currentUserId
                    ? 'inset 0px 4px 6px rgba(0,0,0,0.2)'
                    : '0px 4px 6px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  backgroundColor:
                    filterValues.owner_id === currentUserId
                      ? 'primary.dark'
                      : 'primary.light',
                },
              }}
            >
              Mes tickets assignés
            </ToggleButton>
          </Grid>
          <Grid item>
            <CreateButtonWithState style={{ width: '100%' }} />
          </Grid>
        </Grid>

        <Grid item container spacing={2} alignItems="center">
          <Grid item>
            <FilterForm
              filters={TicketFilter({ ...props })}
              style={{ rowGap: 15, width: 'auto' }}
              className="filter_form_ticket"
            />
          </Grid>
        </Grid>
      </Grid>
    </TopToolbar>
  )
}

const TicketFilter = (props) => {
  const [process_id, setProcessId] = useState(-1)
  const [status_id, setStatusId] = useState(-1)
  const [selectedProcessIds, setSelectedProcessIds] = useState([])
  const [multipleProcessSelected, setMultipleProcessSelected] = useState(false)
  const contextList = useListContext()

  const dataProvider = useDataProvider()
  const [squadChoices, setSquadChoices] = useState([])
  const [coproManagerChoices, setCoproManagerChoices] = useState([])
  const [stateChoices, setStateChoices] = useState([])

  useEffect(() => {
    if (props.filterValues && props.filterValues.process_id) {
      setProcessId(props.filterValues.process_id)
    }
    if (props.filterValues && props.filterValues.process_ids) {
      setSelectedProcessIds(
        Array.isArray(props.filterValues.process_ids)
          ? props.filterValues.process_ids
          : [props.filterValues.process_ids]
      )
      setMultipleProcessSelected(
        Array.isArray(props.filterValues.process_ids) &&
          props.filterValues.process_ids.length > 1
      )
    }
    if (props.filterValues && props.filterValues.status_id) {
      setStatusId(props.filterValues.status_id)
    }
  }, [])

  useEffect(() => {
    if (!contextList.displayedFilters?.next_action_at) {
      const { next_action_at_start, next_action_at_end, ...values } =
        contextList.filterValues
      contextList.setFilters({
        ...values,
      })
    }
  }, [contextList.displayedFilters?.next_action_at])

  useEffect(() => {
    dataProvider
      .getList('copros_monday/squads', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'squad_number', order: 'ASC' },
        filter: {},
      })
      .then(({ data }) => {
        setSquadChoices(data)
      })
      .catch(() => {
        setSquadChoices([])
      })

    dataProvider
      .getList('copros_monday/copro_managers', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'copro_manager', order: 'ASC' },
        filter: {},
      })
      .then(({ data }) => {
        setCoproManagerChoices(data)
      })
      .catch(() => {
        setCoproManagerChoices([])
      })
  }, [dataProvider])

  useEffect(() => {
    const updateURL = (updatedFilterObj) => {
      const newFilterParam = JSON.stringify(updatedFilterObj)
      params.set('filter', newFilterParam)
      // Reload page because react-admin doesn't support changing filters without reloading
      const newUrl = `${window.location.pathname}?${params.toString()}`
      window.location.href = newUrl
    }
    const filter = {}

    // Parse the current URL parameters
    const params = new URLSearchParams(location.search)
    const filterParam = params.get('filter')
    let filterObj = filterParam ? JSON.parse(filterParam) : {}

    // If a process_id is selected in the filter
    if (process_id && process_id !== -1) {
      // Check if a state_name is already selected
      if (filterObj?.state_name) {
        delete filterObj.state_name
        filterObj.process_id = process_id

        updateURL(filterObj)
      }
      filter.process_id = process_id
    }
    // If a process_id is removed, clean state_name and reload
    if (!process_id && filterObj?.state_name) {
      delete filterObj.state_name
      delete filterObj.process_id

      updateURL(filterObj)
    }
    // If a process_id is already in the URL params
    if (filterObj?.process_id) {
      filter.process_id = filterObj?.process_id
    }
    dataProvider
      .getList('states', {
        filter, // Use the filter object
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'step_name', order: 'ASC' },
      })
      .then(({ data }) => {
        // Extract unique state_names
        const uniqueStateNames = Array.from(
          new Set(data.map((state) => state.step_name))
        )
        setStateChoices(
          uniqueStateNames.map((name) => ({
            id: name,
            name: name,
          }))
        )
      })
  }, [dataProvider, process_id])

  return [
    <TextInput fullWidth source="q" label="Rechercher" alwaysOn />,
    <ReferenceInput
      source="copro_id"
      label="Code Copro"
      reference="copros_monday"
      alwaysOn
    >
      <AutocompleteInput
        sx={{ ' button': { padding: '4px;' } }}
        optionValue="id"
        optionText="code"
        size="small"
        resettable={false}
        clearAlwaysVisible={false}
        label="Copropriété"
        matchSuggestion={() => true}
      />
    </ReferenceInput>,
    <ReferenceArrayInput
      source="process_ids"
      reference="tickets/processes"
      alwaysOn
    >
      <AutocompleteArrayInput
        sx={{ ' button': { padding: '4px;' } }}
        optionValue="id"
        optionText="name"
        size="small"
        resettable={false}
        clearAlwaysVisible={false}
        matchSuggestion={() => true}
        onChange={(vals) => {
          const processIds =
            vals === '' ? [] : Array.isArray(vals) ? vals : [vals]
          setSelectedProcessIds(processIds)
          setMultipleProcessSelected(processIds.length > 1)
          if (processIds.length === 1) {
            setProcessId(processIds[0])
          } else {
            setProcessId(undefined)
          }
        }}
      />
    </ReferenceArrayInput>,
    <SelectInput
      key={`state_name_${process_id || 'default'}`}
      source="state_name"
      label="Étape"
      choices={stateChoices}
      alwaysOn
      defaultValue={null}
      allowEmpty
      disabled={multipleProcessSelected}
      sx={{
        marginBottom: 0,
      }}
    />,
    <ReferenceInput
      source="type"
      label="Type"
      reference="processes_types"
      alwaysOn
    >
      <AutocompleteInput
        optionValue="id"
        optionText="name"
        size="small"
        matchSuggestion={() => true}
      />
    </ReferenceInput>,
    <ReferenceInput source="tag_id" label="Tag" reference="tags" alwaysOn>
      <AutocompleteInput
        optionValue="id"
        optionText="title"
        size="small"
        resettable={false}
        clearAlwaysVisible={false}
        matchSuggestion={() => true}
      />
    </ReferenceInput>,
    <TextInput fullWidth={true} source="id" label="Ref" />,
    <ReferenceInput
      source="coowner"
      label="Créateur externe"
      reference="coproprietaires"
    >
      <AutocompleteInput
        optionValue="id"
        optionText="name"
        size="small"
        resettable={false}
        clearAlwaysVisible={false}
        matchSuggestion={() => true}
        label="Créateur externe"
      />
    </ReferenceInput>,
    <ReferenceInput
      source="creator_id"
      label="Créateur"
      reference="users"
      sort={{ field: 'lastname', order: 'ASC' }}
      filter={{ excludeEmptyNames: true }}
      alwaysOn
    >
      <AutocompleteInput
        optionValue="id"
        optionText={(choice) =>
          choice && choice.firstname && choice.lastname
            ? `${choice.firstname} ${choice.lastname}`
            : ''
        }
        filterToQuery={(searchText) => ({ q: searchText })}
        size="small"
        resettable={false}
        clearAlwaysVisible={false}
        label="Créateur"
      />
    </ReferenceInput>,
    <ReferenceInput
      source="owner_id"
      label="Responsable"
      reference="users"
      sort={{ field: 'lastname', order: 'ASC' }}
      filter={{ excludeEmptyNames: true }}
      alwaysOn
    >
      <AutocompleteInput
        optionValue="id"
        optionText={(choice) =>
          choice && choice.firstname && choice.lastname
            ? `${choice.firstname} ${choice.lastname}`
            : ''
        }
        filterToQuery={(searchText) => ({ q: searchText })}
        size="small"
        resettable={false}
        label="Responsable"
      />
    </ReferenceInput>,
    <SelectInput
      source="squad_number"
      label="Squad"
      choices={squadChoices}
      alwaysOn
      sx={{
        marginBottom: 0,
        minWidth: 115,
        '& .MuiInputBase-root': {
          minWidth: '115px',
        },
      }}
    />,
    <SelectInput
      source="resp"
      label="Copro Manager"
      choices={coproManagerChoices}
      alwaysOn
      sx={{
        marginBottom: 0,
      }}
    />,
    <ReferenceInput
      label="Prestataire"
      source="presta"
      reference="prestas"
      alwaysOn
      {...props}
    >
      <AutocompleteInput
        optionValue="id"
        optionText="name"
        size="small"
        resettable={false}
        clearAlwaysVisible={false}
        matchSuggestion={() => true}
        label="Prestataire"
      />
    </ReferenceInput>,
    <SelectInput
      source="priority"
      label="Priorité"
      choices={[
        { id: 1, name: '1' },
        { id: 2, name: '2' },
        { id: 3, name: '3' },
      ]}
      alwaysOn
      sx={{
        marginBottom: 0,
      }}
    />,
    <ProchaineActionFilter alwaysOn />,
    <BooleanInput source="starred" />,
    <SelectInput
      source="trimester"
      style={{ marginTop: 0 }}
      label="Trimestre"
      choices={[
        { id: '1', name: 'T1' },
        { id: '2', name: 'T2' },
        { id: '3', name: 'T3' },
        { id: '4', name: 'T4' },
      ]}
    />,
    <BooleanInput
      source="comments_seen"
      alwaysOn
      sx={{ marginLeft: '10px' }}
    />,
    <BooleanInput
      source="archived"
      label="Masquer les tickets archivés"
      alwaysOn
    />,
  ]
}

//When tickets list is filtered, we say it so that the user
//does not forget he is on a filtered view and then contact support
const ExplicitFilters = (props) => {
  const { res } = props
  var msg = ''
  if (res === 'processowner') {
    msg = 'Vue Process Owner: liste filtrée sur le process sélectionné.'
  }
  if (res === 'gestionnaire') {
    msg =
      'Vue Gestionnaire: liste filtrée sur le process sélectionné, et sur vos copros.'
  }
  return <Typography>{msg}</Typography>
}

export const CreateButtonWithState = (props) => {
  //We want to keep draft ticket id for traceability
  let payload = {}
  const record = useRecordContext(props)
  if (record) {
    // we don't want to send files on query params due to uri too long problem.
    // we extract the zendesk_ticket_ids to ensure we send the latest ones
    const {
      file_with_context: _,
      zendesk_ticket_ids,
      ...allWithoutFiles
    } = record.content
    payload = {
      zendesk_ticket_ids: record.zendesk_ticket_ids,
      draft_id: record.id,
      ...allWithoutFiles,
    }
  }
  //We need to filter undefined values because props.record can come
  //from list of draft tickets (in that case, props.record.id is defined)
  //but it can also come from the regular ticket create button (which uses
  // content to pre-specify process_id when we are on a filtered list, in which case
  // props.record.id is undefined)
  //NOTE: we delete conversations key if it is present since it contains json objects
  //(not compatible with encodeURIComponent) and we don't need it when creating a ticket
  //(conversations were stored in DB already when creating draft ticket)
  delete payload.conversations
  var str = Object.keys(payload)
    .filter((key) => payload[key] !== undefined && payload[key] !== null)
    .map(function (key) {
      let value = payload[key]
      if (Array.isArray(value)) {
        value = JSON.stringify(value)
      }
      return key + '=' + encodeURIComponent(value)
    })
    .join('&')
  let url = '/tickets/create?' + str
  if (!str && window.location.search.length > 1) {
    const params = new URL(document.location).searchParams
    const filter = JSON.parse(params.get('filter'))
    if (filter?.process_id) url += `process_id=${filter?.process_id}`
  }

  if (props.asLink) {
    return <Link href={window.location.origin + url}>Créer ticket</Link>
  } else {
    return (
      <Button
        variant="contained"
        color="secondary"
        href={window.location.origin + url}
        disableElevation
        size="small"
      >
        Créer ticket
      </Button>
    )
  }
}

const ArchiveDraftButton = () => {
  const record = useRecordContext()
  const refresh = useRefresh()
  const notify = useNotify()
  const dataProvider = useDataProvider()

  const handleDelete = () => {
    const confirmed = window.confirm(
      'Êtes-vous certain de vouloir supprimer cet élément ?'
    )

    if (confirmed) {
      dataProvider
        .delete('tickets_drafts', { id: record.id })
        .then(() => {
          notify('Suppression réussie', 'info')
          refresh()
        })
        .catch((error) => {
          notify(`Erreur: ${error.message}`, 'warning')
        })
    }
  }

  return (
    <IconButton color="primary" onClick={handleDelete}>
      <DeleteIcon />
    </IconButton>
  )
}

export const TicketCol = ({ isDraftTicket }) => {
  const record = useRecordContext()
  const column = isDraftTicket ? 'id' : 'reference'
  const condominiumId = record?.content?.condominiumId
  const isCodeEmpty = !record?.code

  return (
    <Grid>
      <Grid item xs={12}>
        <NumberField source={column} label="N° Ticket" sortable={false} />
      </Grid>
      <Grid item xs={12}>
        <CoproCodeOrLibelle
          record={record}
          condominiumId={condominiumId}
          isCodeEmpty={isCodeEmpty}
        />
      </Grid>
    </Grid>
  )
}
const CoproCodeOrLibelle = ({
  condominiumId = '',
  isCodeEmpty = false,
  record,
}) => {
  const [coproData, setCoproData] = useState(null)

  const fetchData = async () => {
    const apiCopros = new ApiCopros()
    const res = await apiCopros.getCopros({ condominiumId })
    setCoproData(res.data?.[0])
  }
  useEffect(() => {
    if (condominiumId && isCodeEmpty) {
      fetchData()
    }
  }, [condominiumId, isCodeEmpty])

  const source = coproData ? 'libelle' : 'code'
  const recorData = coproData ? coproData : record

  return (
    <TextFieldWithTooltip
      record={recorData}
      maxLength={50}
      source={source}
      width={useMediaQuery('(max-width:1600px)') ? 110 : 160}
      sx={{ fontSize: '11px' }}
    />
  )
}

const ProcessStepCol = () => {
  const record = useRecordContext()
  const [states, setStates] = useState()
  const refresh = useRefresh()

  return (
    <Grid container>
      <Grid item xs={12}>
        <ReferenceField
          source="process_id"
          reference="process"
          link={false}
          sortable={true}
        >
          <TextFieldWithTooltip
            minWidth="160px"
            maxLength={160}
            source="name"
            sx={{ fontSize: '12px' }}
          />
        </ReferenceField>
      </Grid>
      <Grid item container xs={12}>
        <Grid
          item
          onClick={() => {
            const request = new Request(
              `${config.API_V1}/states?filter=${encodeURIComponent(
                JSON.stringify({ process_id: record.process_id })
              )}`,
              {
                method: 'GET',
                headers: new Headers({
                  'Content-Type': 'application/json',
                }),
              }
            )
            fetch(request)
              .then(async (response) => await response.json())
              .then((r) => setStates(r))
          }}
        >
          <StepPillWrapper sortable={true} />
        </Grid>
      </Grid>
      {states && (
        <Grid
          item
          xs={12}
          style={{
            position: 'relative',
          }}
        >
          <div
            style={{
              position: 'fixed',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              zIndex: 2,
            }}
            onClick={() => {
              setStates(null)
            }}
          ></div>
          <ul
            style={{
              backgroundColor: 'white',
              minWidth: '200px',
              listStyleType: 'none',
              position: 'absolute',
              top: 0,
              border: '1px solid #cccccc',
              padding: 0,
              zIndex: 3,
            }}
          >
            {states.map((state, idx) => (
              <li
                style={{
                  borderBottom: '1px solid #cccccc',
                  padding: '2px 8px',
                }}
                onClick={() => {
                  const request = new Request(
                    `${config.API_V1}/tickets/${record.id}`,
                    {
                      method: 'PUT',
                      headers: new Headers({
                        'Content-Type': 'application/json',
                      }),
                      body: JSON.stringify({
                        ...record,
                        state_id: state.id,
                      }),
                    }
                  )
                  fetch(request).then(() => {
                    setStates(null)
                    refresh()
                  })
                }}
              >
                {idx + 1}-{state.step_name}
              </li>
            ))}
          </ul>
        </Grid>
      )}
    </Grid>
  )
}

const NextAction = () => {
  const useStyles = makeStyles({
    flashing: {
      animation: `$flashing 1.2s ease infinite`,
    },
    '@keyframes flashing': {
      '0%': {
        background: '#ffa500',
        boxShadow: '0 0 0px #ffa500',
      },
      '50%': {
        background: '#ffa334db',
        boxShadow: '0 0 5px #ffa539db',
      },
      '100%': {
        background: '#ffa500',
        boxShadow: '0 0 0px #ffa500',
      },
    },
  })

  const classes = useStyles()
  const record = useRecordContext()
  const refresh = useRefresh()
  const dataProvider = useDataProvider()
  const checkDate = () => {
    if (!record.next_action_at) {
      return { bg: '', flashing: false }
    }
    let hours = moment(record?.next_action_at).diff(moment(), 'hours')
    if (!hours || hours < 24) {
      return { bg: '', flashing: true }
    } else {
      return { bg: 'rgb(50, 183, 150)', flashing: false }
    }
  }
  const ChipComponent = styled(Chip)((props) => {
    return {
      background: `${props.bg ? props.bg + ' !important' : ''}`,
      minWidth: '85.78px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '& >.MuiChip-label': {
        flex: 1,
        textAlign: 'center',
      },
    }
  })
  const [open, setOpen] = useState(false)
  const [date, setDate] = useState(null)
  const [hasError, setHasError] = useState(false)
  useEffect(() => {
    setDate(() => {
      return record?.next_action_at
        ? moment.utc(record?.next_action_at).format('YYYY-MM-DDTHH:mm')
        : null
    })
  }, [record])
  const handleClose = () => {
    setOpen(false)
    setHasError(false)
  }
  const handleEditNextAction = () => {
    if (!hasError && date) {
      dataProvider
        .update('tickets', {
          id: record.id,
          data: { ...record, next_action_at: date },
        })
        .then(() => {
          refresh()
          handleClose()
        })
        .catch((error) => {
          alert(`${error.message}`, 'warning')
        })
    } else {
      setHasError(true)
    }
  }

  const formattedDate = record?.next_action_at
    ? moment(record.next_action_at).format('DD-MM-YYYY')
    : 'Date action'
  return (
    <>
      <ChipComponent
        className={checkDate().flashing ? classes.flashing : ''}
        label={formattedDate}
        variant="outlined"
        onClick={() => {
          setOpen(true)
        }}
        bg={checkDate().bg}
        // deleteIcon={<CalendarMonth />}
      />
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{'Modifier prochaine action'}</DialogTitle>
        <DialogContent>
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <TextFieldUI
              error={hasError}
              required
              id="datetime-local"
              label="Prochaine action"
              type="datetime-local"
              value={date}
              style={{ width: '100%' }}
              InputLabelProps={{
                shrink: true,
                required: true,
              }}
              onChange={(e) => {
                if (!e?.target?.value) {
                  setHasError(true)
                } else {
                  setHasError(false)
                }
                setDate(e?.target?.value)
              }}
            />
            <Box
              component={'img'}
              src={illustrationProchaineAction}
              width={'200px'}
            />
          </Box>
          {/* <DialogContentText id="alert-dialog-slide-description">
            Let Google help apps determine location. This means sending
            anonymous location data to Google, even when no apps are running.
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Fermer</Button>
          <Button
            onClick={handleEditNextAction}
            disabled={record?.next_action_at == date || hasError}
          >
            Enregistrer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export const DraftActionsCol = () => {
  const record = useRecordContext()
  const [openModalComments, setOpenModalComments] = useState(false)
  const [openZendeskModal, setOpenZendeskModal] = useState(false)

  const [comments, setComments] = useState([])
  const fetchComments = async () => {
    const res = await getComments(record.id, 'tickets_drafts')
    setComments(() => res?.data)
  }
  useEffect(() => {
    fetchComments()
  }, [record?.id])

  return (
    <Grid
      container
      className="draft-actions-col"
      justifyContent="center"
      alignItems="center"
      spacing={1}
      sx={{ padding: 0 }}
    >
      <style>
        {`
          .draft-actions-col .MuiIconButton-root {
            padding: 5px !important;
          }
        `}
      </style>
      <Grid container item xs={12} spacing={0} justifyContent="center">
        <Grid item xs={6} container justifyContent="center">
          <Tooltip title="Commentaires">
            <SmallIconButton
              aria-label="Commentaires"
              color="primary"
              size="small"
              disableRipple={record.comments_seen}
              onClick={() => setOpenModalComments(true)}
              sx={{ opacity: record?.archived ? 0.2 : 1 }}
            >
              <CommentButton record={record} comments={comments} />
            </SmallIconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={6} container justifyContent="center">
          <Tooltip title="Fichier attaché">
            <IconButton aria-label="Fichiers attaché">
              <LinkType
                color="primary"
                size="small"
                linkable_type="tickets_drafts"
              />
            </IconButton>
          </Tooltip>
        </Grid>

        <Grid item xs={6} container justifyContent="center">
          <Tooltip title="Ticket Zendesk associé">
            <IconButton
              aria-label="Ticket Zendesk associé"
              onClick={() => setOpenZendeskModal(true)}
            >
              {record.zendesk_ticket_ids.length > 0 ? (
                <Badge
                  badgeContent={record.zendesk_ticket_ids.length}
                  color="secondary"
                  overlap="circular"
                >
                  <EmailIcon color="primary" />
                </Badge>
              ) : (
                <EmailIcon color="disabled" />
              )}
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={6} container justifyContent="center">
          <Tooltip title="Supprimer">
            <IconButton aria-label="Supprimer">
              <ArchiveDraftButton />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>

      {openZendeskModal && (
        <ZendeskModal
          open={openZendeskModal}
          handleClose={() => {
            setOpenZendeskModal(!openZendeskModal)
            // we have to force the reload to update the react admin record of the tickets
            location.reload()
          }}
          ticket={{
            id: record.id,
            code: record.code,
          }}
          type={DRAFT_TICKET_TYPE}
        />
      )}

      <Comments
        record={record}
        type="tickets_drafts"
        openModalComments={openModalComments}
        setOpenModalComments={setOpenModalComments}
      />
    </Grid>
  )
}

const PriorityColumn = () => {
  const { id, priority } = useRecordContext()
  const [internal_priority, setInternalPriority] = useState(priority)
  const [has_move_foward, setHasToMoveFoward] = useState()
  useEffect(() => {
    setHasToMoveFoward(priority < 3)
  }, [])
  const [update, { data, isLoading, error }] = useUpdate('tickets', {
    id,
    data: { priority: has_move_foward ? priority + 1 : priority - 1 },
    previousData: priority,
  })
  const [disable, setDisable] = useState(false)
  const getIcon = (p) => {
    switch (p) {
      case 1:
        return (
          <PriorityLowIcon
            style={{
              width: '10px',
              height: '10px',
              padding: '0 1px',
            }}
          />
        )
      case 2:
        return (
          <PriorityMediumIcon
            style={{
              verticalAlign: 'middle',
              width: '10px',
              height: '10px',
              padding: '0 1px',
            }}
          />
        )
      case 3:
        return (
          <PriorityHighIcon
            style={{
              width: '10px',
              height: '10px',
              padding: '0 1px',
            }}
          />
        )
    }
  }
  useEffect(() => {
    if (data) {
      setInternalPriority(data.priority)
      if (data.priority === 3) {
        setHasToMoveFoward(false)
      } else if (data.priority === 1) {
        setHasToMoveFoward(true)
      }
      setDisable(false)
    }
  }, [isLoading && !error])
  const getColor = (p) => {
    switch (p) {
      case 1:
        return 'primary'
      case 2:
        return 'secondary'
      case 3:
        return 'error'
    }
  }

  return (
    <Pill
      id={id}
      value={getIcon(internal_priority)}
      status={disable ? 'light' : getColor(internal_priority)}
      style={{
        color: internal_priority === 2 ? 'black' : 'white',
      }}
      onClick={() => {
        setDisable(true)
        update()
      }}
    />
  )
}
export const Creator = () => {
  const record = useRecordContext()
  return (
    <Grid container>
      <Grid item style={{ display: 'flex', columnGap: '3px' }}>
        {record.creator && record.creator.trim() !== '' && (
          <Tooltip title={`${record.creator} (Créateur)`}>
            <div>
              <Pill
                id={record.id}
                style={{ color: 'black' }}
                value={record.creator
                  .split(' ')
                  .map((word) => word[0])
                  .join('')}
                status="secondary"
              />
            </div>
          </Tooltip>
        )}
      </Grid>
    </Grid>
  )
}

export const Responsable = () => {
  const record = useRecordContext()
  return (
    <Grid container>
      <Grid item style={{ display: 'flex', columnGap: '3px' }}>
        {record.owner_fullname && record.owner_fullname.trim() !== '' && (
          <Tooltip title={`${record.owner_fullname} (Responsable)`}>
            <div>
              <Pill
                id={record.id}
                style={{ color: 'black' }}
                value={record.owner_fullname
                  .split(' ')
                  .map((word) => word[0])
                  .join('')}
                status="secondary"
              />
            </div>
          </Tooltip>
        )}
      </Grid>
    </Grid>
  )
}
export const CoproManager = () => {
  const record = useRecordContext()
  return (
    <Grid container>
      <Grid item style={{ display: 'flex', columnGap: '3px' }}>
        {record.resp && record.resp.trim() !== '' && (
          <Tooltip title={`${record.resp} (Copro Manager)`}>
            <div>
              <Pill
                id={record.id}
                style={{ color: 'black' }}
                value={record.resp
                  .split(' ')
                  .map((word) => word[0])
                  .join('')}
                status="secondary"
              />
            </div>
          </Tooltip>
        )}
      </Grid>
    </Grid>
  )
}
export const TicketList = (props) => {
  let [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
    key: 'selection',
  })
  let handleSelect = (ranges) => {
    setDateRange({
      startDate: moment(ranges.selection.startDate).isValid()
        ? ranges.selection.startDate
        : null,
      endDate: moment(ranges.selection.endDate).isValid()
        ? ranges.selection.endDate
        : null,
      key: 'selection',
    })
  }
  let tickets_filter = {
    date_start: dateRange.startDate
      ? moment(dateRange.startDate).format('YYYY-MM-DD HH:mm:ss')
      : null,
    date_end: dateRange.endDate
      ? moment(dateRange.endDate).format('YYYY-MM-DD HH:mm:ss')
      : null,
    ...props.filter,
  }

  // Remove old list filter in locatStorage
  useEffect(() => {
    localStorage.removeItem('RaStore.tickets.listParams')
  }, [])

  return (
    <div>
      <List
        resource="tickets"
        filter={tickets_filter}
        perPage={50}
        exporter={false}
        pagination={<ExtraPagination />}
        title=" "
        sort={{ field: 'created', order: 'DESC' }}
        actions={
          <ListActions
            {...props}
            handleSelect={handleSelect}
            dateRange={dateRange}
          />
        }
        queryOptions={{ refetchOnWindowFocus: false }}
      >
        <MyDatagrid
          isRowSelectable={false}
          bulkActionButtons={false}
          style={{ fontSize: '0.8rem' }}
          size="small"
          sx={{
            '& .MuiTableCell-root': { padding: '8px' },
            '& .MuiTableHead-root': {
              textTransform: 'uppercase',
            },
            '& .MuiTableCell-head': {
              fontWeight: 'bold',
              whiteSpace: 'nowrap',
            },
          }}
        >
          <PriorityColumn label="PRIO" sortBy="priority" />
          <TicketCol label="resources.tickets.fields.ticket_col" />
          <ProcessStepCol label="PROCESS" sortBy="process_stage" />
          <ReferenceField
            label="Tag"
            source="tag_id"
            reference="tags"
            link={false}
            emptyText=""
          >
            <TextFieldWithTooltip maxLength={30} source="title" />
          </ReferenceField>
          <TextFieldWithTooltip
            source="type"
            label="type"
            getValue={(record, defaultValue) => {
              if (record.process_14_free_visit) {
                return (
                  <>
                    {defaultValue}
                    <Chip label="Offerte" size="small" color="secondary" />
                  </>
                )
              }
              return defaultValue
            }}
            maxLength={useMediaQuery('(max-width:1600px)') ? 10 : 40}
            maxLines={2}
          />
          <TextFieldWithTooltip
            source="description"
            label="Description"
            maxLength={useMediaQuery('(max-width:1600px)') ? 50 : 500}
            maxLines={3}
          />
          <Creator label="Creat." />
          <Responsable label="Resp." />
          <NumberField
            source="squad_number"
            label="Squad"
            sx={{
              display: 'block',
              textAlign: 'center',
            }}
          />
          <CoproManager label="CM" />
          <ReferenceField
            label="Presta."
            source="computed_presta"
            reference="prestas"
            link={false}
          >
            <TextFieldWithTooltip maxLength={30} maxLines={2} source="name" />
          </ReferenceField>
          <DateField source="created" label="Cree le" locales="fr-FR" />
          <NextAction sortBy="next_action_at" label="action" />
          <ButtonsColumn width="220px" source="suivis" label="Suivis" />
        </MyDatagrid>
      </List>
    </div>
  )
}

const MyDatagridRow = ({ record, id, children, ...props }) => {
  return (
    <RecordContextProvider value={record}>
      <TableRow>
        {/* data columns based on children */}
        {Children.map(children, (field) => {
          return (
            <TableCell
              key={`${id}-${field?.props?.source}`}
              style={{
                opacity:
                  field?.props?.source !== 'suivis' && record?.archived
                    ? 0.2
                    : 1,
              }}
            >
              {field}
            </TableCell>
          )
        })}
      </TableRow>
    </RecordContextProvider>
  )
}

const MyDatagridBody = (props) => (
  <DatagridBody {...props} row={<MyDatagridRow />} />
)

const MyDatagrid = (props) => {
  const { data, isLoading, isFetching } = useListContext()

  if (isLoading || isFetching) {
    return <Loading />
  }

  return <Datagrid {...props} body={<MyDatagridBody />} />
}

export const TicketListGeneric = (props) => {
  const tickets_filter = props.filter
  const { state } = useLocation()
  // @todo:
  return (
    <div>
      <ExplicitFilters {...props} />
      <TicketList filter={tickets_filter} />
    </div>
  )
}

export const TicketListDraftGeneric = (props) => {
  const tickets_filter = props.filter
  return <TicketListDraft filter={tickets_filter} />
}

const LinkType = ({ record: ParentRecord, linkable_type }) => {
  const record = ParentRecord || useRecordContext()
  if (!record) return null

  return (
    <LinkRelationFromParent
      linkable_type={linkable_type}
      linkable_id={record.id}
      allow_add={false}
      show_on_modal={true}
      show_shared_select={true}
    />
  )
}
export const RenderUploadEditFiles = ({
  formData,
  filesToBind,
  process,
  setFilesToBind,
  coproInternalId,
}) => {
  const [files, setFiles] = useState(filesToBind)
  const [key, setKey] = useState(Math.random().toString(36).substring(7))
  const translate = useTranslate()
  const { setValue } = useFormContext()

  useEffect(() => {
    setFiles(filesToBind)
    setKey(Math.random().toString(36).substring(7))
  }, [filesToBind])

  return process.roles.some((role) => role.show_file_with_context) ? (
    <div key={key} style={{ marginBottom: 10 }}>
      <Typography
        fullWidth
        variant="subtitle1"
        color="primary"
        marginBottom={2}
      >
        {translate('resources.file_with_context.title')}
      </Typography>
      <UpsertFileButton
        resource="file_with_context"
        basePath="file_with_context"
        documentType={FileWithContext.DOCUMENT_TYPE.INTERVENTION}
        issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
        defaultValue={files}
        linkable_id={formData.id}
        copro_id={coproInternalId}
        linkable_type="tickets"
        saveResult={(result) => {
          if (result.accepted_files && result.accepted_files.length > 0) {
            setFilesToBind(result.accepted_files.map((f) => f.toJSON()))
            setValue(
              'file_with_context',
              result.accepted_files.map((f) => f.toJSON())
            )
          }
        }}
        show_shared_select={true}
      />
    </div>
  ) : null
}

export const TicketEditGeneric = (props) => {
  const [filesToBind, setFilesToBind] = useState([])
  const [process, setProcess] = useState({})
  const location = useLocation()
  const [processid, setProcessid] = useState(-1)
  const [coproInternalId, setCoproInternalId] = useState()
  const translate = useTranslate()

  // This awful way to populate processes should be changed in the future.
  useGetOne(
    'process',
    { id: processid, enabled: processid ? true : false },
    {
      onSuccess: (data) => {
        if (data) setProcess(data)
      },
    }
  )
  const transform = (data) => ({
    ...data,
    next_action_at: data?.next_action_at
      ? moment.utc(data?.next_action_at).format('YYYY-MM-DDTHH:mm')
      : null,
  })

  return (
    <Grid container justify="center">
      <Grid item xs={11} md={6}>
        <Edit {...props} transform={transform}>
          <SimpleForm
            redirect="/tickets"
            toolbar={<CustomToolbar />}
            variant="outlined"
          >
            <Typography
              variant="subtitle1"
              color="primary"
              style={{ padding: '1rem 0' }}
            >
              Modification d&apos;un ticket
            </Typography>
            <ReferenceField
              label="Resp."
              source="owner_id"
              reference="users"
              link={false}
            >
              <TextField source="email" />
            </ReferenceField>
            <TextField source="code" label="Code Copro" />
            <ReferenceInput
              source="process_id"
              reference="process_published"
              validate={[required()]}
            >
              <SelectInput
                onChange={(e) => {
                  setProcessid(e.target.value)
                }}
                label="Process"
                fullWidth
                optionText="name"
              />
            </ReferenceInput>
            <ReferenceInput
              label="Ticket parent"
              source="parent_ticket"
              reference="tickets"
            >
              <AutocompleteInput
                fullWidth
                optionText="libelle_id"
                matchSuggestion={() => true}
              />
            </ReferenceInput>
            <DateTimeInput
              fullWidth
              source="next_action_at"
              label="Prochaine Action"
              validate={[required()]}
            />
            <TextInput fullWidth source="libelle" label="Libellé" />
            <DateField source="deadline" label="Deadline" />
            <ReferenceInput
              actions={false}
              allowEmpty
              label="Tag interne"
              source="tag_id"
              reference="tags"
            >
              <SelectInput fullWidth optionText="title" />
            </ReferenceInput>
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                if (formData.process_id === undefined) return null
                window.context['context-process'] = formData.process_id
                setProcessid(formData.process_id)
                return (
                  <Show
                    actions={false}
                    id={formData.process_id}
                    resource="process"
                    basePath="/"
                    title=" "
                    component="div"
                    style={{
                      width: '100%',
                    }}
                  >
                    <ReferenceInput
                      label="Etape"
                      source="state_id"
                      reference="states"
                      variant="outlined"
                    >
                      <SelectInput fullWidth optionText="step_fullname" />
                    </ReferenceInput>
                  </Show>
                )
              }}
            </FormDataConsumer>
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                if (formData.process_id === undefined) return null
                return (
                  <Show
                    actions={false}
                    id={formData.process_id}
                    resource="process"
                    basePath="/"
                    title=" "
                    component="div"
                    style={{ width: '100%' }}
                  >
                    <DynamicInputComponentBO
                      formData={formData}
                      variant="outlined"
                      {...props}
                    />
                  </Show>
                )
              }}
            </FormDataConsumer>
            <FormDataConsumer>
              {({ formData }) => {
                useGetList(
                  'file_with_context',
                  {
                    filter: {
                      linkable_type: 'tickets',
                      linkable_id: formData.id,
                      upload_by_type: null,
                    },
                    enabled: formData.id ? true : false,
                  },
                  {
                    onSuccess: ({ data }) => {
                      if (data) setFilesToBind(data)
                    },
                  }
                )
                return (
                  process.roles && (
                    <RenderUploadEditFiles
                      process={process}
                      formData={formData}
                      filesToBind={filesToBind}
                      coproInternalId={formData.copro_internal_id}
                      setFilesToBind={setFilesToBind}
                    />
                  )
                )
              }}
            </FormDataConsumer>
            <ReferenceManyField
              label="Tickets enfant"
              reference="tickets"
              target="parent_ticket"
            >
              <Datagrid rowClick="show">
                <TextField label="Numero" source="id" />
                <TextField label="Libellé" source="libelle" />
                <DateField
                  showTime
                  label="Créé le"
                  source="created"
                  locales="fr-FR"
                />
              </Datagrid>
            </ReferenceManyField>
            <ReferenceManyField
              label="Activité"
              reference="tickets_activity"
              target="ticket_id"
            >
              <Datagrid bulkActionButtons={false}>
                <TextField label="Activité" source="activity" />
                <DateField label="Créé le" showTime source="created" />
              </Datagrid>
            </ReferenceManyField>
            {/* <FormDataConsumer>
              {({ formData }) =>
                ((filesToBind && filesToBind.length > 0) ||
                  (!process &&
                    process.roles &&
                    process.roles.some(
                      (role) => role.show_file_with_context
                    ))) && (
                  <UpsertFileButton
                    resource="file_with_context"
                    basePath="file_with_context"
                    documentType={FileWithContext.DOCUMENT_TYPE.INTERVENTION}
                    issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
                    defaultValue={filesToBind}
                    linkable_id={formData.id}
                    linkable_type="tickets"
                    saveResult={(result) => {
                      if (
                        result.accepted_files &&
                        result.accepted_files.length > 0
                      ) {
                        setFilesToBind(
                          result.accepted_files.map((f) => f.toJSON())
                        )
                        setValue(
                          'file_with_context',
                          result.accepted_files.map((f) => f.toJSON())
                        )
                      }
                    }}
                    show_shared_select={true}
                  />
                )
              }
            </FormDataConsumer> */}
          </SimpleForm>
        </Edit>
      </Grid>
    </Grid>
  )
}

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)
  return date
}

const DialogEditToolbar = () => (
  <Toolbar>
    <SaveButton />
  </Toolbar>
)

const CoproFicheEditDialog = ({ record, ...props }) => {
  if (!record) return null

  return (
    <DialogForm id={record.copro_internal_id} {...props}>
      <SimpleForm
        variant="outlined"
        toolbar={<DialogEditToolbar />}
        resource="copros_fiche"
        basePath="/"
      >
        <Typography fullWidth variant="subtitle1">
          Vérifier et mettre à jour les infos d&apos;accès
        </Typography>
        <TextInput fullWidth source="fiche_adresse" label="Adresse" />
        <TextInput
          fullWidth
          source="fiche_complement_adresse"
          label="Fiche comp. adresse"
        />
        <TextInput fullWidth source="fiche_codes_acces" label="Codes d'accès" />
        <TextInput fullWidth source="fiche_vigik" label="Vigik" />
        <TextInput fullWidth source="fiche_interphones" label="Interphones" />
      </SimpleForm>
    </DialogForm>
  )
}

export const CreateToolbar = (props) => {
  const { isCheckedAnotherTicket, setCreateAnotherTicket } = props
  return (
    <Toolbar>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          flexDirection: 'row-reverse',
        }}
      >
        <SaveNewWithFileButton
          color="primary"
          variant="contained"
          disableElevation
          {...props}
        >
          Enregistrer
        </SaveNewWithFileButton>
        <FormControlLabel
          control={
            <Checkbox
              checked={isCheckedAnotherTicket}
              onChange={(e) => {
                e.preventDefault()
                setCreateAnotherTicket(!isCheckedAnotherTicket)
              }}
            />
          }
          label="Créer autre ticket"
        />
      </Box>
    </Toolbar>
  )
}

export const CoownerTicketsTooltip = ({ id, source, copro_id, process_id }) => {
  const translate = useTranslate()
  const [ticket_quantity, setTicketQuantity] = useState(0)
  const {
    data: ticketQuantityData,
    isLoading: isLoadingTicketQuantityData,
    errorTicketQuantityData,
  } = useGetManyReference(
    'tickets',
    {
      target: 'copro_id',
      id: copro_id,
      filter: {
        [source]: id,
        process_id: process_id,
        trimester: 'current',
        count_only: true,
      },
    },
    {
      enabled: source && process_id && copro_id ? true : false,
    }
  )
  useEffect(() => {
    if (ticketQuantityData !== undefined) {
      const [{ quantity }] = ticketQuantityData
      setTicketQuantity(quantity)
    }
  }, [ticketQuantityData])
  const { data, isLoading, error } = useGetManyReference(
    'tickets',
    {
      target: 'copro_id',
      id: copro_id,
      pagination: { page: 1, perPage: 5 },
      filter: {
        [source]: id,
        process_id: process_id,
        trimester: 'current',
      },
    },
    {
      enabled:
        !isLoadingTicketQuantityData &&
        !errorTicketQuantityData &&
        ticket_quantity > 0,
    }
  )
  const redirect = useRedirect()

  return (
    <HtmlTooltip
      maxWidth="100%"
      sx={{ marginTop: 0 }}
      title={
        !isLoading &&
        !error &&
        data && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">
                Actuellement {ticket_quantity} tickets ouverts
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TableContainer>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Copro code</TableCell>
                      <TableCell>
                        {translate(`resources.tickets.fields.process_step_col`)}
                      </TableCell>
                      <TableCell>
                        {translate(`resources.tickets.fields.type`)}
                      </TableCell>
                      <TableCell>Deadline</TableCell>
                      <TableCell>Libelle</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((row, idx) => (
                      <TableRow
                        key={idx}
                        onClick={() => {
                          redirect('show', 'tickets', row.id)
                        }}
                      >
                        <TableCell>
                          <TextFieldWithTooltip
                            record={row}
                            maxLength={50}
                            source="code"
                          />
                        </TableCell>
                        <TableCell>
                          <TextFieldWithTooltip
                            record={row}
                            maxLength={50}
                            source="status"
                          />
                        </TableCell>
                        <TableCell>
                          <TextFieldWithTooltip
                            record={row}
                            maxLength={50}
                            source="type"
                          />
                        </TableCell>
                        <TableCell>
                          <DateField record={row} source="deadline" />
                        </TableCell>
                        <TableCell>
                          <TextFieldWithTooltip
                            record={row}
                            maxLength={50}
                            source="libelle"
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        )
      }
    >
      <Typography
        style={{ color: 'rgba(0, 0, 0, 0.54)', marginBottom: '1.5rem' }}
      >
        Actuellement {ticket_quantity} tickets ouverts
      </Typography>
    </HtmlTooltip>
  )
}

// Temporary disabled, Contact should only be edited in Copromatic. Need to repair this functionnality with the new Backend

// export const CoownerEditDialog = ({ id, onSuccess }) => {
//   const translate = useTranslate()

//   return (
//     <DialogForm
//       id={id}
//       open={id}
//       onSuccess={onSuccess}
//       showButtonProps={{
//         fullWidth: true,
//         variant: 'outlined',
//         color: 'primary',
//         size: 'large',
//         sx: { marginBottom: '20px;' },
//         label: translate('resources.tickets.fields.verify_coowner_info'),
//       }}
//       transform={(data) => {
//         data.phone = formatPhone(data.phone)
//         return data
//       }}
//       title="Informations copropriétaires"
//     >
//       <SimpleForm
//         resource="ext_contactpref"
//         basePath="/"
//         toolbar={<DialogEditToolbar />}
//         variant="outlined"
//         sx={{ padding: '0 24px' }}
//       >
//         <Grid container>
//           <Grid item xs={12}>
//             <p>
//               <Typography>
//                 Voici les coordonnées du copropriétaire. Actualise-les, la prise
//                 en compte est immédiate.
//               </Typography>
//             </p>
//           </Grid>
//           <Grid item xs={6}>
//             <SelectInput
//               source="prefcontact"
//               label="Préférence contact"
//               fullWidth
//               choices={[
//                 { id: 'all', name: 'Email et SMS' },
//                 { id: 'email', name: 'Email' },
//                 { id: 'sms', name: 'SMS' },
//               ]}
//             />
//             <TextInput source="email" label="Email" fullWidth />
//             <TextInput
//               source="phone"
//               label="Mobile"
//               fullWidth
//               validate={validatePhone}
//             />
//           </Grid>
//           <Grid style={{ textAlign: 'center', margin: 'auto' }}>
//             <img
//               style={{
//                 width: '215px',
//                 margin: 'auto',
//               }}
//               src={`${config.PUBLIC_URL}/img/coowner_data_edit.svg`}
//             />
//           </Grid>
//         </Grid>
//       </SimpleForm>
//     </DialogForm>
//   )
// }

export const TicketCreateGeneric = (props) => {
  const useStyles = makeStyles({
    loadingHoverContainer: {
      position: 'fixed',
      width: '100%',
      height: '100%',
      zIndex: 9999,
      textAlign: 'center',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgb(0 0 0 / 58%)',
    },
    specifications_of_coownership: {
      marginBottom: '1.7rem',
    },
  })
  const classes = useStyles()
  const dataProvider = useDataProvider()
  const [process, setProcess] = useState()
  const [is_draft, setDraft] = useState(false)
  const [createAnotherTicket, setCreateAnotherTicket] = useState(false)
  const notify = useNotify()
  const location = useLocation()
  var params = parse(location.search)
  const navigate = useNavigate()
  // The field id array to disable;
  const [disable_fields, setDisableFields] = useState([])
  const [processid, setProcessid] = useState(params.process_id)
  const [filesToBind, setFilesToBind] = useState([])
  const [filesFromParams, setFilesFromParams] = useState([])
  const [show_loading, setShowLoading] = useState(false)

  const redirectTo = useRedirect()
  const fetchDraftData = () => {
    if (params.draft_id) {
      setShowLoading(true)
      dataProvider
        .getOne(`tickets_drafts`, { id: params.draft_id })
        .then(({ data }) => {
          const files = data.content.file_with_context
            ? data.content.file_with_context
            : []
          setFilesToBind(files)
          setFilesFromParams(files)
          setShowLoading(false)
        })
        .catch((e) => {
          setShowLoading(false)
          console.log(e)
        })
    }
  }
  useEffect(() => {
    fetchDraftData()
  }, [params.draft_id])

  const handleSave = (data) => {
    const { file_with_context, id, is_draft } = data

    const relation = new Relation({
      linkable_type: is_draft ? 'tickets_drafts' : 'tickets',
      linkable_id: id,
    })
    if (filesFromParams && filesFromParams.length > 0) {
      dataProvider.updateMany('file_with_context', {
        ids: filesFromParams.map((f) => f.id),
        data: relation.toJSON(),
      })
    }
    if (file_with_context && file_with_context.length > 0)
      dataProvider
        .updateMany('file_with_context', {
          ids: file_with_context.map((f) => f.id),
          data: relation.toJSON(),
        })
        .then(() => {
          notify(
            "Le ticket HelloApp a été créé. Un ticket Zendesk d'information assigné au responsable va être créé",
            { type: 'success' }
          )
          if (!createAnotherTicket) {
            redirectTo('edit', 'tickets', id, data)
          }
        })
        .catch((e) => {
          throw new BindFile(
            'tickets',
            id,
            file_with_context.map((f) => f.id).join(', ')
          )
        })
    else if (is_draft) {
      if (!createAnotherTicket) {
        navigate('/tickets_drafts', { state: data })
      } else {
        notify('Pré-ticket enregistré avec succès', { type: 'success' })
      }
    } else {
      notify(
        'Le ticket HelloApp a été créé. Un ticket Zendesk d’information assigné au responsable va être créé',
        { type: 'success' }
      )
      if (!createAnotherTicket) {
        redirectTo('edit', 'tickets', id, data)
      }
    }
  }

  const onFailure = (error) => {
    alert(error.message)
    //No idea why notify is not working
    notify(`${error.message}`)
  }
  useEffect(() => {
    dataProvider
      .getOne('process', { id: processid || -1, enabled: true })
      .then(({ data }) => {
        setProcess(data)
      })
      .catch((e) => {})
  }, [processid])
  const [processQualificationTypeform, setProcessQualificationTypeform] =
    useState(undefined)

  //NOTE: we need ticket_fields info for dataprovider, so that it can convert image fields to base64
  //We put ..params first because we don't want it to override ticket_fields (sometimes, url ends up containing ticket_fields=[Object Object])

  const init_values = {
    ...params,
    ticket_fields: process ? process.ticket_fields : [],
    is_draft: false,
    priority: 1,
  }

  //NOTE: We use a Show component inside the FormDataConsumer to fetch the process object
  //and the fields key.
  //By luck, input fields inside the Show still have their values taken into
  //account by the outer Create component

  //NOTE2: for is_draft, initially we tried adding a save draft button in toolbar but
  //I could not make it work. I passed setDraft to the Toolbar component and added a new button
  //in toolbar with a specific handleClick that set is_draft to true before calling props.handlesubmit
  //but it did not work. handleSubmit always took the previous is_draft value, some kind of "one render cycle late" or sth alike
  //Alternative was to use a standalone SimpleForm component without Toolbar and make custom Buttons inside SimpleForm
  //but even then there were issues: handling redirect was a pain, and moreover Buttons inside SimpleForm
  // had a {} props.record even when the form was filled. Trying to use formData to update a record state variable caused an infinite loop.
  //So in the end I decided to go for the simple option: just use a booleanInput, and one, regular, save button in a toolbar

  const TypeFormHandler = () => {
    const { setValue } = useFormContext()
    return (
      <Button
        color="primary"
        fullWidth
        size="large"
        variant="contained"
        onClick={() => {
          createTypeformPopup(setValue)
        }}
        disableElevation
        style={{ marginBottom: '20px' }}
      >
        {' '}
        Cliquer pour qualifier la demande
      </Button>
    )
  }
  // @todo: See why the process id is a string instead of a number.
  const createTypeformPopup = (setValue) => {
    const popUP = createPopup(processQualificationTypeform, {
      onSubmit: async (data) => {
        setShowLoading(true)
        popUP.close()
        try {
          const response = await fetch(
            `${config.API_V1}/unrestricted/tickets/typeform/${processQualificationTypeform}?response_id=${data.responseId}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                auth_token: config.auth_token,
              },
            }
          )
          if (!response.ok) {
            const body = await response.json()
            throw new Error(
              `HTTP error! status: ${response.status}, ${body.error.description}`
            )
          }
          const items = await response.json()
          if (items && items.length > 0) {
            const { question, answers } = items.shift()
            setValue('libelle', `${question} ${answers}`)
            setValue(
              'description',
              items
                .map((item) => `${item.question}: ${item.answers}`)
                .join('\r\n'),
              false
            )
          }
        } catch (e) {
          // handle the error, displaying a message to the user
          notify(e.message)
        } finally {
          setShowLoading(false)
        }
      },
    })
    popUP.open()
  }

  const [copro, setCopro] = useState(null)
  const [coproInternalId, setCoproInternalId] = useState(null)

  const CoproPopulator = ({ setCopro, setCoproInternalId, ...props }) => {
    const choiceContext = useChoicesContext()
    return (
      <AutocompleteInput
        onChange={(e) => {
          setCopro(
            e === ''
              ? undefined
              : choiceContext.allChoices.filter((choice) => choice.id === e)[0]
          )
          Api.copros.getByMondayId(e).then((value) => {
            setCoproInternalId(value.data.copro_internal_id)
          })
        }}
        fullWidth
        optionText="code"
        optionValue="id"
        matchSuggestion={() => true}
        validate={[required()]}
        disabled={props.disabled}
        helperText={props.disabled ? props.disabledInfo : ''}
      />
    )
  }

  if (params.copro_id) {
    Api.copros.getByMondayId(params.copro_id).then((value) => {
      setCoproInternalId(value.data.copro_internal_id)
    })
  }

  const translate = useTranslate()
  const [pristine, setPristine] = useState(false)
  const CreateFileHandler = () => {
    const { setValue } = useFormContext()
    useEffect(() => {
      setValue(
        'notify_cs_on_ticket_creation',
        process.notify_cs_on_ticket_creation,
        { shouldDirty: true }
      )
      setValue(
        'notify_janitor_on_ticket_creation',
        process.notify_janitor_on_ticket_creation,
        { shouldDirty: true }
      )
      setPristine(false)
    }, [])

    useEffect(() => {
      if (location.state) setValue('process_id', location.state.process_id)
    }, [location.state && location.state.process_id])

    return (
      <>
        <Typography
          fullWidth
          variant="subtitle1"
          color="primary"
          marginBottom={2}
        >
          {translate('resources.file_with_context.title')}
        </Typography>
        <UpsertFileButton
          fullWidthButton
          resource="file_with_context"
          basePath="file_with_context"
          documentType={FileWithContext.DOCUMENT_TYPE.INTERVENTION}
          issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
          defaultValue={filesToBind}
          copro_id={coproInternalId}
          showPrestaSelection={true}
          saveResult={(result) => {
            if (result.accepted_files && result.accepted_files.length > 0) {
              setFilesToBind(result.accepted_files.map((f) => f.toJSON()))
              setValue(
                'file_with_context',
                result.accepted_files.map((f) => f.toJSON())
              )
            }
          }}
          show_shared_select={true}
        />
      </>
    )
  }

  const validateTicketCreation = (values) => {
    const errors = {}
    if (!values.type) {
      errors.type = 'Type est requis'
    }
    if (!values.copro_id) {
      errors.copro_id = 'Copro est requis'
    }
    if (!values.process_id) {
      errors.process_id = 'Process est requis'
    }
    return errors
  }

  const urlParams = new URLSearchParams(window.location.search)
  const zendeskIds = urlParams.get('zendesk_ticket_ids')

  const PETITE_DEMANDE_STANDARD_T1_PROCESS_ID = '17'

  return (
    <div style={{ padding: '16px 0' }}>
      <Grid container spacing={2} justify="center">
        <Grid item xs={11} md={6}>
          <Alert color="rgb(222, 243, 255)">
            <Typography>
              Attention : certaines informations saisies ici peuvent être
              visibles par les copropriétaires et/ou prestataires.
            </Typography>
          </Alert>
        </Grid>
      </Grid>
      <Grid container spacing={2} justify="center">
        <Grid item xs={11} md={6}>
          <Create
            {...props}
            pristine={pristine}
            onFailure={onFailure}
            mutationOptions={{
              onSuccess: handleSave,
              meta: { zendesk_ticket_ids: zendeskIds },
            }}
          >
            <SimpleForm
              defaultValues={init_values}
              variant="outlined"
              toolbar={
                <CreateToolbar
                  setCreateAnotherTicket={setCreateAnotherTicket}
                  isCheckedAnotherTicket={createAnotherTicket}
                />
              }
              style={{ backgroundColor: is_draft ? draft_color : 'white' }}
            >
              <ReferenceInput
                source="process_id"
                reference="process_published"
                filter={{ creation: true }}
              >
                <SelectInput
                  onChange={(e) => {
                    setProcessid(e.target.value)
                  }}
                  label="Process"
                  fullWidth
                  optionText="name"
                  validate={[required()]}
                />
              </ReferenceInput>
              <ReferenceInput
                label="Code Copro"
                source="copro_id"
                reference="copros_monday"
              >
                <CoproPopulator
                  setCopro={setCopro}
                  setCoproInternalId={setCoproInternalId}
                  disabled={filesToBind.length > 0}
                  disabledInfo="Des fichiers sont renseignés. Pour changer la copro, merci de les supprimer préalablement."
                />
              </ReferenceInput>
              <DateTimeInput
                fullWidth
                source="next_action_at"
                label="Prochaine Action"
                sx={{ mt: 2 }}
              />
              <FormDataConsumer>
                {({ formData }) => {
                  return (
                    <>
                      {copro && copro.copro_internal_id && (
                        <CoproFicheEditDialog
                          {...props}
                          record={copro}
                          showButtonProps={{
                            fullWidth: true,
                            // disabled: !copro.copro_internal_id,
                            variant: 'outlined',
                            color: 'primary',
                            size: 'large',
                            sx: { marginBottom: '20px;' },
                            label: "Vérifier les infos d'accès",
                          }}
                        />
                      )}
                    </>
                  )
                }}
              </FormDataConsumer>
              {['4', '6', '13'].indexOf(processid) !== -1 &&
                copro &&
                copro.specifications_of_coownership && (
                  <Grid
                    container
                    spacing={2}
                    justify="center"
                    className={classes.specifications_of_coownership}
                  >
                    <Grid item xs={12} md={12}>
                      <Alert color="#FCCC60">
                        <Typography>
                          {translate(
                            'resources.copro_fiche.fields.specifications_of_coownership'
                          )}
                        </Typography>
                        <RichTextField
                          record={copro}
                          source="specifications_of_coownership"
                          disabled={true}
                        />
                      </Alert>
                    </Grid>
                  </Grid>
                )}
              {processQualificationTypeform && <TypeFormHandler />}
              <TextInput
                fullWidth
                source="libelle"
                label="Libellé du ticket"
                sx={{ mt: 2 }}
                validate={[required()]}
              />
              <FormDataConsumer>
                {({ formData, ...rest }) => (
                  <ReferenceInput
                    source="state_id"
                    reference="states"
                    variant="outlined"
                    filter={{ process_id: formData.process_id }}
                  >
                    <SelectInput
                      disabled={!formData.process_id}
                      fullWidth
                      optionText="step_fullname"
                    />
                  </ReferenceInput>
                )}
              </FormDataConsumer>
              <FormDataConsumer>
                {({ formData, ...rest }) => {
                  setDraft(formData.is_draft)
                  if (formData.process_id <= 0) {
                    return null
                  }
                  setProcessid(formData.process_id)
                  window.context['context-process'] = formData.process_id
                  //NOTE: the process fetch is async so sometimes ticket deadline
                  //won't be init right away, it will take another field edit for the update to happen
                  if (formData.deadline == undefined && process !== undefined) {
                    var d = new Date()
                    formData.deadline = d.addDays(process.deadline)
                  }
                  return null
                }}
              </FormDataConsumer>
              <FormDataConsumer>
                {({ formData, ...rest }) => {
                  if (!formData.process_id) {
                    return null
                  }
                  if (!formData.copro_id) {
                    return null
                  }
                  if (process)
                    setProcessQualificationTypeform(
                      process.qualification_typeform_id
                    )
                  //NOTE: I dunno why but here style information works on Show component and not on SimpleShowLayout
                  //while on Create component it doesn't and must be put under SimpleForm component
                  // This is added in order to keep track of the qualification type when the process type is changed
                  return (
                    <DynamicInputComponentBO
                      disabledFields={disable_fields}
                      formData={{ ...formData, copro }}
                      record={process}
                      variant="outlined"
                    >
                      {processid && parseInt(formData[`coowner`]) > 0 && (
                        <div>
                          <CoownerTicketsTooltip
                            id={formData[`coowner`]}
                            source={`coowner`}
                            process_id={processid}
                            copro_id={formData.copro_id}
                          />
                          {/* Temporary disabled, Contact should only be edited in Copromatic. Need to repair this functionnality with the new Backend */}
                          {/* <CoownerEditDialog id={formData[`coowner`]} /> */}
                        </div>
                      )}
                    </DynamicInputComponentBO>
                  )
                }}
              </FormDataConsumer>
              {/* TODO: delete all the code related to this feature
               {!params.draft_id && (
                <BooleanInput
                  source="is_draft"
                  label="Créer un pré-ticket uniquement"
                />
              )} */}

              <BooleanInput
                source="notify_cs_on_ticket_creation"
                defaultValue={null}
                disabled={processid === PETITE_DEMANDE_STANDARD_T1_PROCESS_ID}
              />

              <BooleanInput
                source="notify_janitor_on_ticket_creation"
                defaultValue={null}
              />
              <PriorityColumnInCreateTicket />
              <FormDataConsumer>
                {({ formData }) => {
                  if (
                    process &&
                    process.roles.some((role) => role.show_file_with_context) &&
                    coproInternalId
                  )
                    return (
                      <CreateFileHandler coproInternalId={coproInternalId} />
                    )
                }}
              </FormDataConsumer>
              <FormDataConsumer>
                {({ formData }) => {
                  if (formData.draft_id) {
                    return <TicketComments draftTicketId={formData.draft_id} />
                  }
                }}
              </FormDataConsumer>
            </SimpleForm>
          </Create>
        </Grid>
      </Grid>
      {show_loading && (
        <div className={classes.loadingHoverContainer}>
          <Loading />
        </div>
      )}
    </div>
  )
}
const TicketComments = ({ draftTicketId }) => {
  const [comments, setComments] = useState([])
  const fetchComments = async () => {
    const res = await getComments(draftTicketId, 'tickets_drafts')
    setComments(() => res.data)
  }
  useEffect(() => {
    fetchComments()
  }, [draftTicketId])

  if (comments.length) {
    return (
      <Box sx={{ mt: '20px', width: '100%' }}>
        <Typography>Commentaires</Typography>
        <CommentsList
          comments={comments}
          setComments={setComments}
          ticketId={draftTicketId}
          type="tickets_drafts"
        />
      </Box>
    )
  }
  return null
}
const PriorityColumnInCreateTicket = () => {
  const { setValue, ...rest } = useFormContext()

  const [internal_priority, setInternalPriority] = useState(1)
  const [has_move_foward, setHasToMoveFoward] = useState(true)
  useEffect(() => {
    setValue('priority', internal_priority)
  }, [internal_priority])
  const getIcon = (p) => {
    switch (p) {
      case 1:
        return (
          <PriorityLowIcon
            style={{
              width: '15px',
              height: '15px',
              paddingTop: '5px',
            }}
          />
        )
      case 2:
        return (
          <PriorityMediumIcon
            style={{
              width: '15px',
              height: '15px',
              verticalAlign: 'middle',
              padding: '5px 0',
            }}
          />
        )
      case 3:
        return (
          <PriorityHighIcon
            style={{
              width: '15px',
              height: '15px',
              paddingTop: '5px',
            }}
          />
        )
    }
  }

  const getColor = (p) => {
    switch (p) {
      case 1:
        return 'primary'
      case 2:
        return 'secondary'
      case 3:
        return 'error'
    }
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Pill
        id={'ticket-create'}
        value={getIcon(internal_priority)}
        status={getColor(internal_priority)}
        style={{
          color: internal_priority === 2 ? 'black' : 'white',
          cursor: 'pointer',
        }}
        onClick={(e) => {
          e.preventDefault()
          setInternalPriority((current_internal_priority) => {
            if (has_move_foward) {
              if (current_internal_priority + 1 === 3) {
                setHasToMoveFoward(false)
              }
              return current_internal_priority + 1
            } else {
              if (current_internal_priority - 1 === 1) {
                setHasToMoveFoward(true)
              }
              return current_internal_priority - 1
            }
          })
        }}
      />
      <div style={{ marginLeft: '10px' }}>Priorité</div>
    </div>
  )
}
const TicketDialog = ({ record, handleClose, open, ...props }) => (
  <Dialog fullWidth={true} maxWidth="sm" onClose={handleClose} open={open}>
    <Show
      {...props}
      id={record.process_id}
      resource="process"
      basePath="/"
      title=" "
      component="div"
      actions={false}
    >
      <SimpleShowLayout style={{ padding: '1rem' }}>
        <DynamicViewComponentBO formData={record} record={record} />
        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            variant="contained"
            disableElevation
          >
            Fermer
          </Button>
        </DialogActions>
      </SimpleShowLayout>
    </Show>
  </Dialog>
)

const CustomNotifDialog = (props) => {
  const record = useRecordContext(props)
  const notify = useNotify()
  const [roleid, setRoleid] = useState(undefined)
  if (!record) return null

  const contacts = record.contacts

  if (contacts === undefined) return null

  const choices = contacts
    .filter((c) => c['send_notifs'] === true)
    .map((c) => {
      return {
        id: c['role_id'],
        name: c['role'],
      }
    })
  choices.push({
    id: 'all',
    name: 'Tous',
  })

  const onSuccess = () => {
    notify('Relance effectuée!')
    props.handleClose()
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      onClose={props.handleClose}
      open={props.open}
    >
      <DialogTitle>Relancer les interlocuteurs</DialogTitle>
      <DialogContent>
        <Create
          basePath="/"
          title=" "
          resource="notifs"
          redirect={false}
          mutationOptions={{ onSuccess }}
        >
          <SimpleForm
            redirect={false}
            variant="outlined"
            defaultValues={{
              ticket_id: record.id,
              origin: window.location.origin,
            }}
          >
            <SelectInput
              source="role_id"
              label="Role"
              choices={choices}
              validate={[required()]}
            />
            <TextInput
              multiline
              rows={6}
              source="notif_text"
              label="Override Notif Email"
            />
            <TextInput
              multiline
              rows={6}
              source="notif_subject"
              label="Override Sujet Email"
            />
            <TextInput
              multiline
              rows={6}
              source="notif_text_sms"
              label="Override Notif SMS"
            />
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                if (formData.role_id !== roleid) {
                  setRoleid(formData.role_id)
                }
                if (
                  formData.role_id !== undefined &&
                  formData.role_id !== null &&
                  formData.role_id !== 'all' &&
                  formData.role_id !== roleid
                ) {
                  var contact = contacts.filter(
                    (c) => c['role_id'] === formData.role_id
                  )[0]
                  formData.notif_text = contact.notif_text
                  formData.notif_text_sms = contact.notif_text_sms
                }
                return null
              }}
            </FormDataConsumer>
          </SimpleForm>
        </Create>
      </DialogContent>
    </Dialog>
  )
}

const ActionButtons = (props) => {
  const record = useRecordContext()
  const [openWorkflowDialog, setOpenWorkflowDialog] = useState(false)
  const [openTicketDialog, setOpenTicketDialog] = useState(false)
  const [openCustomNotifDialog, setOpenCustomNotifDialog] = useState(false)

  const toggleOpenTicketDialog = () => setOpenTicketDialog(!openTicketDialog)
  const toggleOpenWorkflowDialog = () =>
    setOpenWorkflowDialog(!openWorkflowDialog)
  const toggleOpenCustomNotifDialog = () =>
    setOpenCustomNotifDialog(!openCustomNotifDialog)

  return (
    <Grid container spacing={2}>
      <Grid item>
        <Button
          size="small"
          variant="contained"
          color="secondary"
          startIcon={<VisibilityIcon />}
          onClick={toggleOpenTicketDialog}
          disableElevation
        >
          Consulter le ticket
        </Button>
      </Grid>
      {openTicketDialog && (
        <TicketDialog
          {...props}
          record={record}
          open={openTicketDialog}
          handleClose={toggleOpenTicketDialog}
        />
      )}

      <Grid item>
        <Button
          size="small"
          variant="outlined"
          onClick={toggleOpenWorkflowDialog}
          style={{ margin: 'auto' }}
        >
          Voir le workflow
        </Button>
      </Grid>
      <WorkflowDialog
        {...props}
        record={record}
        open={openWorkflowDialog}
        handleClose={toggleOpenWorkflowDialog}
      />
      <Grid item>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={toggleOpenCustomNotifDialog}
          disableElevation
        >
          Relancer les interlocuteurs
        </Button>
      </Grid>
      <CustomNotifDialog
        {...props}
        record={record}
        open={openCustomNotifDialog}
        handleClose={toggleOpenCustomNotifDialog}
      />
    </Grid>
  )
}

const WorkflowDialog = (props) => {
  const { state_transitions, status } = useRecordContext(props)

  if (!state_transitions) return null

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      onClose={props.handleClose}
      open={props.open}
    >
      <DialogTitle>Workflow du process</DialogTitle>
      <DialogContent>
        {state_transitions.map((transition) => (
          <Typography
            key={transition.id}
            variant="body2"
            color={status === transition.start_state ? 'primary' : ''}
            gutterBottom
          >
            Dans l&apos;étape <b>{transition.start_state || 'Non défini'}</b>,
            le rôle <b>{transition.role || 'Non défini'}</b> doit saisir le(s)
            champ(s) :{' '}
            {transition.input_columns && transition.input_columns.length > 0
              ? transition.input_columns
                  .filter((col) => col && col.label)
                  .map((col) => col.label)
                  .join(', ')
              : 'Aucun champ requis'}{' '}
            et peut voir les champs :{' '}
            {transition.view_columns && transition.view_columns.length > 0
              ? transition.view_columns
                  .filter((col) => col && col.label)
                  .map((col) => col.label)
                  .join(', ')
              : 'Aucun champ visible'}
          </Typography>
        ))}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={props.handleClose}>
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  )
}

//Somewhere else we needed context-process, but now that the states endpoint requires it, we have
//to set it everywhere
const Hack = () => {
  const record = useRecordContext()
  window.context['context-process'] = record.process_id
  return null
}

const TicketsCommentsBlockWrapper = (props) => {
  const [show, setShow] = useState(false)
  const record = useRecordContext()
  if (record === undefined) return null

  const handleClick = () => setShow(!show)
  return (
    <>
      <Button color="primary" variant="outlined" onClick={handleClick}>
        Voir les commentaires
      </Button>
      {show && (
        <Comments
          type={'tickets'}
          openModalComments={show}
          setOpenModalComments={setShow}
          {...props}
          record={record}
        />
      )}
    </>
  )
}

const TitleField = () => {
  const record = useRecordContext()

  return (
    <Typography align="left" variant="body2">
      {record.name}
    </Typography>
  )
}

const CodePillField = () => {
  const record = useRecordContext()

  return <Pill id={record.id} value={record.code} />
}
const StepPillField = () => {
  const record = useRecordContext()

  return <Pill id={record.id} value={record.step_fullname} status="secondary" />
}

const DeadlinePillField = ({ isMobile }) => {
  const record = useRecordContext()
  const deadline = moment(record.deadline)
  const today = moment()
  const isPast = moment(deadline).isBefore(today) && record.step === 1

  return (
    <>
      {isMobile && (
        <Typography
          variant="caption"
          display="block"
          color="textSecondary"
          gutterBottom
        >
          Date limite
        </Typography>
      )}
      <Pill
        id={record.id}
        value={deadline.format('D/M/Y')}
        status={isPast ? 'error' : 'success'}
      />
    </>
  )
}
const CreatorPill = () => {
  const [coowner, setCoowner] = useState(null)
  const [loading, setLoading] = useState(true)
  const record = useRecordContext()

  const coowner_id = record.coowner
  useEffect(() => {
    if (coowner_id) {
      Api.coproprietaires.getCoproprietaire(coowner_id).then((value) => {
        setCoowner(value.data)
        setLoading(false)
      })
    } else {
      setLoading(false)
    }
  }, [coowner_id])

  if (loading) return null

  return (
    <>
      <Pill
        id={record.id}
        value={coowner ? coowner.name : 'Interne'}
        status="info"
      />
    </>
  )
}
const InfosTicket = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('xs'))

  return (
    <>
      {isMobile ? (
        <SimpleShowLayout>
          <ReferenceField
            addLabel={false}
            source="process_id"
            reference="process"
            link={false}
          >
            <TitleField />
          </ReferenceField>
          <ReferenceField
            label="Code copro"
            source="copro_id"
            reference="copros_monday"
            link={false}
          >
            <CodePillField />
          </ReferenceField>
          <CreatorPill label="Créateur" />
          <DeadlinePillField isMobile={isMobile} />
          <TextField source="libelle" label="Description" />

          <ReferenceField
            actions={false}
            emptyText="N/A"
            label="Tag interne"
            source="tag_id"
            reference="tags"
            link={false}
            sortable={false}
          >
            <TextField source="title" />
          </ReferenceField>
          <ReferenceField
            actions={false}
            label="Etape"
            source="state_id"
            reference="states"
            link={false}
          >
            <StepPillField />
          </ReferenceField>
        </SimpleShowLayout>
      ) : (
        <Table aria-label="infos ticket">
          <TableHead>
            <TableRow>
              <TableCell>Process</TableCell>
              <TableCell align="left">Code copro</TableCell>
              <TableCell align="left">Créateur</TableCell>
              <TableCell align="left">Date limite</TableCell>
              <TableCell align="left">Libellé</TableCell>
              <TableCell align="left">Description</TableCell>
              <TableCell align="left">Tag interne</TableCell>
              <TableCell align="left">Etape</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                <ReferenceField
                  addLabel={false}
                  source="process_id"
                  reference="process"
                  link={false}
                >
                  <TitleField />
                </ReferenceField>
              </TableCell>
              <TableCell align="left">
                <ReferenceField
                  label="Code copro"
                  source="copro_id"
                  reference="copros_monday"
                  link={false}
                >
                  <CodePillField />
                </ReferenceField>
              </TableCell>
              <TableCell align="left">
                <CreatorPill label="Créateur" />
              </TableCell>
              <TableCell align="left">
                <DeadlinePillField isMobile={isMobile} />
              </TableCell>
              <TableCell align="left" style={{ maxWidth: '300px' }}>
                <TextField source="libelle" label="Libellé" />
              </TableCell>
              <TableCell align="left" style={{ maxWidth: '300px' }}>
                <TextField source="description" label="Description" />
              </TableCell>
              <TableCell align="left">
                <ReferenceField
                  actions={false}
                  emptyText="N/A"
                  label="Tag interne"
                  source="tag_id"
                  reference="tags"
                  link={false}
                  sortable={false}
                >
                  <TextField source="title" />
                </ReferenceField>
              </TableCell>
              <TableCell align="left">
                <ReferenceField
                  actions={false}
                  label="Etape"
                  source="state_id"
                  reference="states"
                  link={false}
                >
                  <StepPillField />
                </ReferenceField>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
    </>
  )
}
export const TicketShowGeneric = ({ open, setOpen, ...props }) => {
  const classes = useStyles()

  return (
    <Fragment>
      <Drawer
        anchor="right"
        open={open}
        onClose={() => {
          setOpen(false)
        }}
      >
        <div style={{ marginTop: 10, marginLeft: 10 }}>
          <Button
            onClick={() => {
              setOpen(false)
            }}
          >
            <KeyboardArrowRight />
            <Typography>Fermer</Typography>
          </Button>
        </div>
        <Show actions={false} {...props}>
          <SimpleShowLayout style={{ padding: '1rem' }}>
            <Hack {...props} />
            <InfosTicket />
            <br />
            <ActionButtons {...props} />
            <br />
            <ReferenceManyField
              addLabel={false}
              reference="tickets"
              target="parent_ticket"
              label=" "
            >
              <Datagrid rowClick="show">
                <TextField label="Numero" source="id" />
                <TextField label="Libellé" source="libelle" />
                <DateField
                  showTime
                  label="Créé le"
                  source="created"
                  locales="fr-FR"
                />
              </Datagrid>
            </ReferenceManyField>
            <ReferenceManyField
              addLabel={false}
              reference="tickets_activity"
              target="ticket_id"
              label=" "
            >
              <Datagrid bulkActionButtons={false}>
                <RichTextField label="Activité" source="activity" />
                <DateField label="Créé le" showTime source="created" />
              </Datagrid>
            </ReferenceManyField>
            <br />
            <TicketsCommentsBlockWrapper {...props} />
          </SimpleShowLayout>
        </Show>
      </Drawer>
    </Fragment>
  )
}
